import { render, staticRenderFns } from "./UnidadeLinhasTable.vue?vue&type=template&id=6afaaba5&scoped=true&"
import script from "./UnidadeLinhasTable.vue?vue&type=script&lang=js&"
export * from "./UnidadeLinhasTable.vue?vue&type=script&lang=js&"
import style0 from "./UnidadeLinhasTable.vue?vue&type=style&index=0&id=6afaaba5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afaaba5",
  null
  
)

export default component.exports